module.exports = __webpack_public_path__ + "static/me-90cb037e282857353a150e4430dd0e41.png";